<template>
  <div id="app">
    <coverHeader/>
    <router-view/>
    <infoFooter/>
  </div>
</template>

<script>
  import coverHeader from './components/coverHeader.vue';
  import infoFooter from './components/infoFooter.vue';

  export default {
    name: 'App',
    components: {
      coverHeader,
      infoFooter,
    }
  }
</script>

<style lang="scss">
  @import './assets/css/fontello.css';
  * {
    box-sizing: border-box;
    font-family: 微軟正黑體;
  }
  body {
    margin: 0;
  }
  ul {
    margin: 0;
    padding: 0;
  }
  p, h1, h2, h3, h4 {
    margin: 0;
  }
  a {
    text-decoration: none;
  }
  .container {
    width: 80%;
    margin: 0 auto;
  }
  .col-2, .col-3, .col-9, .col-10, .col-12 {
    display: inline-block;
    float: left;
  }
  .col-2 {
    width: 16%;
  }
  .col-3 {
    width: 25%;
  }
  .col-9 {
    width: 75%;
  }
  .col-10 {
    width: 83%;
  }
  .col-12 {
    width: 100%;
  }
  .title, .des, .job {
    color: #3D1101;
  }
  .title {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
  }
  .clearfix:after {
    content: "";
    display: table;
    clear: both;
  }

  @media (min-width: 768px) {
    .col-2-t {
      width: 16%;
    }
    .col-3-t {
      width: 25%;
    }
    .col-4-t {
      width: 33%;
    }
    .col-6-t {
      width: 50%;
    }
    .col-8-t {
      width: 66%;
    }
    .col-9-t {
      width: 75%
    }
    .col-10-t {
      width: 83%;
    }
  }
  @media (min-width: 992px) { 

  }
</style>



// WEBPACK FOOTER //
// src/App.vue